export const HomeData1 = [
    {
        linkHome:"https://www.linkedin.com/in/ahmed-azzoz-aa1873246/",
        iconHome:"ri-linkedin-box-line"
    },
    {
        linkHome:"https://github.com/Ahmed-Azoz1",
        iconHome:"ri-github-line"
    },
    {
        linkHome:"https://www.facebook.com/profile.php?id=100083517627587",
        iconHome:"ri-dribbble-line"
    },
]



export const HomeData2 = [
    {
        infoTitle:`السيرة الذاتيه`,
        infoDescription1:'اهلا انا احمد, FullStack Developer.',
        infoDescription2:'تصميم وبرمجة مواقع انترنت.',
        infoDescription3:'مقيم فى مصر.',
    },
    {
        infoTitle:`تواصل معنا`,
        infoDescription1:'مصر , الفيوم',
        infoDescription2:'ahmedazouz022@gmail.com',
        infoDescription3:'+20103505324',
    },
    {
        infoTitle:`الخدمات`,
        infoDescription1:'تصميم مواقع الويب , فرونت اند',
        infoDescription2:'وتطوير مواقع الويب , باك اند',
    },
]

export const HomeData3 = [
    {
        infoTitle:'سنوات الخبرة',
        infoNumber:'03+',
    },
    {
        infoTitle:'المشاريع المنجزة',
        infoNumber:'09+',
    },
    {
        infoTitle:'المشاريع التدريبية',
        infoNumber:'07+',
    },
]